import { fetchAppVersionLogic } from './fetchAppVersionLogic';

export const logic = [fetchAppVersionLogic];
